// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3Nmaa","head":"Table_head__1oTdJ","col":"Table_col__2yPsl"};